export class MetaTagsSet {
    public title!: string;
    public description!: string;
}
